(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // «Productos»: clic o toque abre/cierra el mega menú; clic fuera o Esc lo cierra.
  (function () {
    var items = document.querySelectorAll('.nav-item--mega');
    if (!items.length) return;
    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var b = it.querySelector('.nav-item__trigger'); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (it) {
      var b = it.querySelector('.nav-item__trigger');
      if (!b) return;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !it.classList.contains('is-open');
        closeAll(it);
        it.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      it.addEventListener('mouseleave', function () { if (matchMedia('(hover: hover)').matches) closeAll(); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.nav-item--mega')) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  })();

  // Header inteligente: bajar oculta la barra, el primer scroll hacia arriba la revela.
  // Evita tener que subir hasta arriba del todo para volver a tocar el menú.
  (function () {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;
    var NEAR_TOP = 12; // cerca del tope: siempre visible

    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      // No reaccionar si un drawer/modal está abierto (global.js pone body overflow:hidden)
      if (document.body.style.overflow === 'hidden') { lastY = y; return; }
      if (y <= NEAR_TOP) {
        header.classList.remove('is-hidden');
      } else if (y > lastY && y > header.offsetHeight) {
        header.classList.add('is-hidden');   // bajando -> ocultar
      } else if (y < lastY) {
        header.classList.remove('is-hidden'); // subiendo -> revelar
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
